import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient , HttpParams} from '@angular/common/http';
import { Router } from '@angular/router';
declare let $: any;

@Component({
  selector: 'app-harshita-gautam',
  templateUrl: './harshita-gautam.component.html',
  styleUrls: ['./harshita-gautam.component.scss']
})
export class HarshitaGautamComponent implements OnInit {

  option1 = true;
  option2 = false;

  //add user form start
  registerForm: FormGroup;
  submitted = false;
  router: any;
  constructor( public fb: FormBuilder, private http: HttpClient, private _router: Router){

    this.registerForm = this.fb.group({
      candidateName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      city: ['', Validators.required],
      sttype: ['', Validators.required],
      chooseAcademy: ['', Validators.required],
      instituteName: ['', Validators.required],
      payamount: ['']
    })
  }
  get f() { return this.registerForm.controls; }

  submitForm() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }
  
    var formData: any = new FormData();

  formData.append("candidateName", this.registerForm.value.candidateName);
  formData.append("email", this.registerForm.value.email);
  formData.append("phone", this.registerForm.value.phone);
  formData.append("city", this.registerForm.value.city);
  formData.append("sttype", this.registerForm.value.sttype);
  formData.append("chooseAcademy", this.registerForm.value.chooseAcademy);
  formData.append("instituteName", this.registerForm.value.instituteName);
  formData.append("payamount", this.registerForm.value.payamount);
   //console.log(formData);
   this.http.post('https://ghrscf.com/classes/registration_code.php', formData).subscribe(
    (response: any) => console.log(response),
    (error: any) => console.log(error)
  );
  // this.router.navigate(['/demo']);
  this._router.navigateByUrl('/viewharshita-gautam');
}

changediv(divid: string) {

  if (divid === "nc_signup") {
    this.option1 = true;
    this.option2 = false;
  }
  else if (divid === "cc_signup") {
    console.log('bye');
    this.option1 = false;
    this.option2 = true;
  }
}
  ngOnInit(): void {
  //   $(document).ready(() =>{
  //     $('input[name$="choose-acdemy"]').click(() =>{
  //         var inputValue = $(this).attr("value");
  //         var targetBox = $("." + inputValue);
  //         $(".payamount").not(targetBox).hide();
  //         $(targetBox).show();
  //     });
  // });
  }

}
